import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Text } from '@/Components/Preferences/PreferencesComponents/Content';
import { c, msgid } from 'ttag';
const SharingStatusText = ({ subscriptionState }) => {
    const { usedInvitationsCount, allowedInvitationsCount } = subscriptionState;
    const text = c('B6.Preferences.Subscription.Info').ngettext(msgid `You've used ${usedInvitationsCount} out of ${allowedInvitationsCount} subscription invite.`, `You've used ${usedInvitationsCount} out of ${allowedInvitationsCount} subscription invites.`, allowedInvitationsCount);
    return _jsx(Text, { className: "mt-1", children: text });
};
export default observer(SharingStatusText);
